import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import specialOptions, { receivedDebinAction } from "../actionMaker";

const useActionByDebinState = (actionsDebin, debin, setDrawer) => {
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();
    const { environmentCuit } = useSelector((state) => state.debin);

    const debinActions = () => {
        let contextMenuActions = [];

        contextMenuActions = [
            ...contextMenuActions,
            ...specialOptions(debin, environmentCuit, (action, debinInfo) =>
                receivedDebinAction(action, debinInfo, dispatch, setDrawer),
            ),
        ];
        return contextMenuActions;
    };

    useEffect(() => {
        if (!actionsDebin) {
            return;
        }
        const itemsContextMenu = debinActions();
        setOptions(
            itemsContextMenu
                ?.filter((item) => item.label !== "debin.negotiate.debin")
                ?.map((item) => ({ text: item.label, func: item.onClick, textType: "I18N" })),
        );
    }, [actionsDebin, debin?.status]);
    return { options };
};

export default useActionByDebinState;
